





































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm, Input } from 'element-ui'
// 接口
import { editPassword } from '@/api/users'

@Component({
  name: 'Password',
})
export default class extends Vue {
  @Prop() private dialogFormVisible!: any



  private validatePwd = (rule: any, value: any, callback: Function) => {
    const reg = /^[0-9A-Za-z]{6,20}$/
   if (!value) {
      callback(new Error('请输入'))
    }else if (!reg.test(value)) {
      callback(new Error('6 - 20位密码，数字或字母，区分大小写'))
    } else {
      callback()
    }
  }
  private validatePass2 = (rule, value, callback) => {
    if (!value) {
      callback(new Error('请再次输入密码'))
    }else if (value !== this.form.newPassword) {
      callback(new Error('密码不一致，请重新输入密码'))
    } else {
      callback()
    }
  }
  rules = {
    oldPassword: [{ validator: this.validatePwd, trigger: 'blur' }],
    newPassword: [{ validator: this.validatePwd, trigger: 'blur' }],
    affirmPassword: [{ validator: this.validatePass2, trigger: 'blur' }],
  }
  private form = {} as any
  private affirmPassword = ''
  handleSave() {
    ;(this.$refs.form as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const parnt = {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
        }
        await editPassword(parnt)
          .then((res) => {
            if (res.data.code == 1 ) {
              this.$message.success('密码更改成功！')
//             this.pageQuery()
            }else {
             // this.$message.error('密码修改失败!')
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            this.$message.error('请求出错了：' + err.message)
          })


        this.$emit('handleclose')
        ;(this.$refs.form as ElForm).resetFields()
      }

      else {
       return false

      }
    })

  }

  handlePwdClose() {
    ;(this.$refs.form as ElForm).resetFields()
    this.$emit('handleclose')
  }
}
